import React from 'react'
import { Radio } from 'atoms/Radio'
import translate from 'core/translate'
import styles from './deviceSettings__audioPlayer.jcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { cn } from 'ethcss'
import { Typography } from 'atoms/Typography'
import { SwitchButton } from '../../../atoms/SwitchButton'

const DeviceSettingsAudioPlayer = (p_: {
    settings: { audioPlayerEnabled: string; showVolumeHandle: string }
    onChange: (data: any) => void
}) => {
    const onChange = (value: string, event: string | null, key = 'options') => {
        const data: any = {
            ...p_.settings,
            [key]: value,
        }

        p_.onChange(data)
    }

    return (
        <>
            <div className={styles.switchWrapper}>
                <SwitchButton
                    checked={p_.settings.audioPlayerEnabled === 'on'}
                    onChange={() => {
                        onChange(p_.settings.audioPlayerEnabled === 'on' ? 'off' : 'on', null, 'audioPlayerEnabled')
                    }}
                    className={`test-settings-toggle_${
                        p_.settings.audioPlayerEnabled === 'on' ? 'enabled' : 'disabled'
                    }`}
                />
                <div className={cn(styles.switchCaption)}>
                    <Typography type="title">{translate('audioPlayerMode')}</Typography>
                </div>
            </div>
            <div className={styles.switchWrapper}>
                <SwitchButton
                    checked={p_.settings.showVolumeHandle === 'on'}
                    onChange={() => {
                        onChange(p_.settings.showVolumeHandle === 'on' ? 'off' : 'on', null, 'showVolumeHandle')
                    }}
                    disabled={p_.settings.audioPlayerEnabled === 'off'}
                    className={`test-settings-toggle_${p_.settings.showVolumeHandle === 'on' ? 'enabled' : 'disabled'}`}
                />
                <div className={cn(styles.switchCaption)}>
                    <Typography type="title">{translate('showVolumeHandle')}</Typography>
                </div>
            </div>
        </>
    )
}

export default DeviceSettingsAudioPlayer
